import { render, staticRenderFns } from "./UpdateSeries.vue?vue&type=template&id=183e31fc&scoped=true&"
import script from "./UpdateSeries.vue?vue&type=script&lang=js&"
export * from "./UpdateSeries.vue?vue&type=script&lang=js&"
import style0 from "./UpdateSeries.vue?vue&type=style&index=0&id=183e31fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e31fc",
  null
  
)

export default component.exports